import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=0d6f80cd&scoped=true"
import script from "./commission.vue?vue&type=script&lang=js"
export * from "./commission.vue?vue&type=script&lang=js"
import style0 from "./commission.vue?vue&type=style&index=0&id=0d6f80cd&prod&lang=css&scoped=true"
import style1 from "./commission.vue?vue&type=style&index=1&id=0d6f80cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6f80cd",
  null
  
)

export default component.exports